import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TapoLighting() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>Tapo Smart Lighting | TP-Link | SeguraTech</title>
        <meta
          name="description"
          content="Discover TP-Link Tapo smart lighting — bulbs, strips, and ambient light systems designed for effortless control, scheduling, and energy savings."
        />
        <meta property="og:title" content="Tapo Smart Lighting | TP-Link" />
        <meta
          property="og:description"
          content="Smart lighting for every room — control brightness, colours, and schedules with the TP-Link Tapo app."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seguratech.co.uk/tplink/lighting" />
        <meta property="og:image" content="/tplink-lighting-banner.jpg" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-4xl mx-auto px-4 py-24 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight text-[#C6A564] mb-6">
          Tapo Smart Lighting
        </h1>
        <p className="text-lg text-white/80 mb-10">
          Bring your home to life with Tapo’s smart lighting range.  
          Adjustable brightness, warm and cool tones, or vivid colours — all controlled through the Tapo app or your voice assistant.
        </p>
        <p className="text-white/70">
          SeguraTech integrates TP-Link Tapo lighting into fully automated systems, ensuring your comfort and security never depend on a switch.
        </p>
      </section>

      {/* Product Grid */}
      <section className="max-w-6xl mx-auto px-4 pb-24">
        <div className="grid md:grid-cols-3 gap-8 text-center">

          {/* Tapo L530E Smart Bulb */}
          <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
            <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">Tapo L530E Smart Bulb</h3>
            <p className="text-white/80 mb-4">
              Full colour control, brightness adjustment, and scheduling — ideal for ambience, energy efficiency, and convenience.
            </p>
            <Link
              to="/tplink/smartplugs"
              className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
            >
              Explore Tapo Lighting
            </Link>
          </div>

          {/* Tapo L630 Spotlight */}
          <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
            <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">Tapo L630 Spotlight</h3>
            <p className="text-white/80 mb-4">
              Compact smart spotlights perfect for kitchens, offices, or accent lighting. Control colour temperature or automate with Tapo Hub.
            </p>
            <Link
              to="/tplink/smarthubs"
              className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
            >
              Compatible with Smart Hubs
            </Link>
          </div>

          {/* Tapo L920 Light Strip */}
          <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition">
            <h3 className="text-2xl font-semibold text-[#C6A564] mb-3">Tapo L920 Light Strip</h3>
            <p className="text-white/80 mb-4">
              Flexible RGB light strip offering millions of colours and dynamic scenes. Set the mood, sync to music, or schedule illumination.
            </p>
            <Link
              to="/tplink/deco"
              className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
            >
              Integrate with Mesh Wi-Fi
            </Link>
          </div>

        </div>
      </section>

      {/* Integration Info */}
      <section className="max-w-4xl mx-auto px-4 pb-16 text-center">
        <h2 className="text-3xl font-bold text-[#C6A564] mb-4">Voice & App Control</h2>
        <p className="text-white/80 mb-6">
          Control your lighting hands-free using Alexa or Google Assistant, or manage every device with the intuitive Tapo mobile app.
        </p>
        <h2 className="text-3xl font-bold text-[#C6A564] mb-4">Energy Efficient Automation</h2>
        <p className="text-white/80">
          Schedule lights to match your routine, save energy automatically, and enhance security with presence simulation while away.
        </p>
      </section>

      {/* Back Link */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
